"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstance = exports.attachTypeApi = exports.getKeyThenIncreaseKey = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_notification_1 = tslib_1.__importDefault(require("rc-notification"));
var NormalLoading_1 = require("../../Icons/NormalLoading");
var PromptCheckCircleFill_1 = require("../../Icons/PromptCheckCircleFill");
var PromptCloseCircleFill_1 = require("../../Icons/PromptCloseCircleFill");
var PromptErrorFill_1 = require("../../Icons/PromptErrorFill");
var PromptInfoCircleFill_1 = require("../../Icons/PromptInfoCircleFill");
var useMessage_1 = tslib_1.__importDefault(require("./hooks/useMessage"));
require("./style");
var messageInstance;
var defaultDuration = 3;
var defaultTop;
var key = 1;
var localPrefixCls = 'anq-message';
var transitionName = 'move-up';
var getContainer;
var maxCount;
var rtl = false;
function getKeyThenIncreaseKey() {
    return key++;
}
exports.getKeyThenIncreaseKey = getKeyThenIncreaseKey;
function setMessageConfig(options) {
    if (options.top !== undefined) {
        defaultTop = options.top;
        messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) {
        defaultDuration = options.duration;
    }
    if (options.prefixCls !== undefined) {
        localPrefixCls = options.prefixCls;
    }
    if (options.getContainer !== undefined) {
        getContainer = options.getContainer;
    }
    if (options.transitionName !== undefined) {
        transitionName = options.transitionName;
        messageInstance = null; // delete messageInstance for new transitionName
    }
    if (options.maxCount !== undefined) {
        maxCount = options.maxCount;
        messageInstance = null;
    }
    if (options.rtl !== undefined) {
        rtl = options.rtl;
    }
}
function getRCNotificationInstance(args, callback) {
    var prefixCls = args.prefixCls || localPrefixCls;
    if (messageInstance) {
        callback({
            prefixCls: prefixCls,
            instance: messageInstance,
        });
        return;
    }
    rc_notification_1.default.newInstance({
        prefixCls: prefixCls,
        transitionName: transitionName,
        style: { top: defaultTop },
        getContainer: getContainer,
        maxCount: maxCount,
    }, function (instance) {
        if (messageInstance) {
            callback({
                prefixCls: prefixCls,
                instance: messageInstance,
            });
            return;
        }
        messageInstance = instance;
        callback({
            prefixCls: prefixCls,
            instance: instance,
        });
    });
}
var typeToIcon = {
    info: PromptInfoCircleFill_1.PromptInfoCircleFill,
    success: PromptCheckCircleFill_1.PromptCheckCircleFill,
    error: PromptCloseCircleFill_1.PromptCloseCircleFill,
    warning: PromptErrorFill_1.PromptErrorFill,
    loading: NormalLoading_1.NormalLoading,
};
function getRCNoticeProps(args, prefixCls) {
    var _a;
    var duration = args.duration !== undefined ? args.duration : defaultDuration;
    var IconComponent = typeToIcon[args.type];
    var messageClass = (0, classnames_1.default)("".concat(prefixCls, "-custom-content"), (_a = {},
        _a["".concat(prefixCls, "-").concat(args.type)] = args.type,
        _a["".concat(prefixCls, "-rtl")] = rtl === true,
        _a));
    return {
        key: args.key,
        duration: duration,
        style: args.style || {},
        className: args.className,
        content: (React.createElement("div", { className: messageClass },
            args.icon || (IconComponent && React.createElement(IconComponent, null)),
            React.createElement("span", null, args.content))),
        onClose: args.onClose,
        onClick: args.onClick,
    };
}
function notice(args) {
    var target = args.key || key++;
    var closePromise = new Promise(function (resolve) {
        var callback = function () {
            if (typeof args.onClose === 'function') {
                args.onClose();
            }
            return resolve(true);
        };
        getRCNotificationInstance(args, function (_a) {
            var prefixCls = _a.prefixCls, instance = _a.instance;
            instance.notice(getRCNoticeProps(tslib_1.__assign(tslib_1.__assign({}, args), { key: target, onClose: callback }), prefixCls));
        });
    });
    var result = function () {
        if (messageInstance) {
            messageInstance.removeNotice(target);
        }
    };
    result.then = function (filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
function isArgsProps(content) {
    return (Object.prototype.toString.call(content) === '[object Object]' &&
        !!content.content);
}
var api = {
    open: notice,
    config: setMessageConfig,
    destroy: function (messageKey) {
        if (messageInstance) {
            if (messageKey) {
                var removeNotice = messageInstance.removeNotice;
                removeNotice(messageKey);
            }
            else {
                var destroy = messageInstance.destroy;
                destroy();
                messageInstance = null;
            }
        }
    },
};
function attachTypeApi(originalApi, type) {
    originalApi[type] = function (content, duration, onClose) {
        if (isArgsProps(content)) {
            return originalApi.open(tslib_1.__assign(tslib_1.__assign({}, content), { type: type }));
        }
        if (typeof duration === 'function') {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({ content: content, duration: duration, type: type, onClose: onClose });
    };
}
exports.attachTypeApi = attachTypeApi;
['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) { return attachTypeApi(api, type); });
api.warn = api.warning;
api.useMessage = (0, useMessage_1.default)(getRCNotificationInstance, getRCNoticeProps);
/** @private test only function. Not work on production */
// eslint-disable-next-line no-confusing-arrow
var getInstance = function () { return (process.env.NODE_ENV === 'test' ? messageInstance : null); };
exports.getInstance = getInstance;
exports.default = api;
//# sourceMappingURL=index.js.map